import classNames from 'classnames';

import { PricingCardsSkeleton } from '@picsart/monetization/PricingCards';

import HorizontalContainerWrapper from 'pages/NewHome/HorizontalContainerWrapper';

import useStyles from './styles';

function PricingCardsSectionFallback() {
  const styles = useStyles({ titleColor: '' });

  return (
    <HorizontalContainerWrapper className={styles.wrapper}>
      <i className={classNames(styles.titleSkeleton, 'skeleton')} />
      <PricingCardsSkeleton />
    </HorizontalContainerWrapper>
  );
}

export default PricingCardsSectionFallback;
